<template>
  <div class="newMark row align-center" :class="text ? 'text' : ''">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: { text: String },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.newMark {
  box-shadow: $shadow;
  border-radius: 20px;
  background: $orange;
  color: #fff;
  padding: 0px 4px;
  font-size: 10px;
  height: 15px;
  min-width: 7px;
  float: right;
  @media (max-width: $small) {
    margin-right: 25px;
  }
  &.text {
    margin-top: -17px;
    margin-left: -21px;
    @media (max-width: $small) {
      min-width: 27px;
    }
  }
}
</style>